import { useStoreState, useStoreActions } from 'easy-peasy';

// Wrapper hook that returns the auth slice of the easy-peasy store.
export function useAuth() {
  const user = useStoreState((state) => state.auth.user);
  const userId = useStoreState((state) => state.auth.userId);
  const loading = useStoreState((state) => state.auth.loading);
  const credits = useStoreState((state) => state.auth.credits);
  const subscription = useStoreState((state) => state.auth.subscription);
  const billingCountry = useStoreState((state) => state.auth.billingCountry);
  const isFreePlan = useStoreState((state) => state.auth.isFreePlan);

  const setUser = useStoreActions((actions) => actions.auth.setUser);
  const initAuthListener = useStoreActions((actions) => actions.auth.initAuthListener);
  const setCredits = useStoreActions((actions) => actions.auth.setCredits);
  const setSubscription = useStoreActions((actions) => actions.auth.setSubscription);
  const setBillingCountry = useStoreActions((actions) => actions.auth.setBillingCountry);
  const setIsFreePlan = useStoreActions((actions) => actions.auth.setIsFreePlan);

  return {
    user,
    userId,
    loading,
    credits,
    setUser,
    initAuthListener,
    setCredits,
    subscription,
    setSubscription,
    billingCountry,
    setBillingCountry,
    isFreePlan,
    setIsFreePlan
  };
}
